export const pxToRem = (size, fontSize = 14, htmlFontSize = 16) => {
  const coef = fontSize / 14;

  return `${(size / htmlFontSize) * coef}rem`;
};

export const pxToLineHeight = (size, fontSize = 14) => size / fontSize;

export const getCountryByLanguage = (lang) => ({
  en: "gb",
}[lang]);

export const transformArticleDate = (date, hrefLang = "en") => {
  const transformDate = new Date(date);
  return new Date(Date.UTC(
    transformDate.getUTCFullYear(),
    transformDate.getUTCMonth(),
    transformDate.getUTCDate(),
    transformDate.getUTCHours(),
    transformDate.getUTCMinutes(),
    transformDate.getUTCSeconds(),
    transformDate.getUTCMilliseconds(),
  )).toLocaleDateString(hrefLang, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
  // return transformDate.toLocaleDateString(hrefLang, {
  //   year: "numeric",
  //   month: "short",
  //   day: "numeric",
  // });
};
